import { useCallback, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import { SettingsEntrySource } from '@/analytics/enums/settings-entry.enums'
import { AuthContext } from '@/context/auth-context'
import { useAppDispatch } from '@/store/store-hooks'
import { openSettingsModal } from '@/store/slices/ui-state.slice'
import { useRuntimeFeatureFlag } from '@/feature-flags/useRuntimeFeatureFlag'
import { RuntimeFeatureFlag } from '@/feature-flags/definitions'

export function useCollaborationUpsell() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { userAccountData } = useContext(AuthContext)
  const isOrgAccount = !!userAccountData?.isOrgAccount
  const { enabled: settingsRevampEnabled } = useRuntimeFeatureFlag(RuntimeFeatureFlag.SETTINGS_REVAMP_FOUNDATION)

  const handleUpsellClick = useCallback(() => {
    if (settingsRevampEnabled) {
      dispatch(openSettingsModal({ section: 'create-organization', settingsEntrySource: SettingsEntrySource.Direct }))
    } else {
      navigate('/dashboard/account')
    }
  }, [settingsRevampEnabled, dispatch, navigate])

  return {
    showUpsell: !isOrgAccount,
    handleUpsellClick,
  }
}
